/**
 * LOVE Bags 2026 — Prints Index Client-Side Filtering
 *
 * All filtering is DOM-based (no network calls) because every print card is
 * already rendered server-side. Filters + search toggle visibility only.
 *
 * Diagnostic logging under [LB Prints Index] prefix — same pattern as PDP.
 */

(function () {
  'use strict';

  console.info('[LB Prints Index] script executing');

  const container = document.querySelector('[data-lb-prints-index]');
  if (!container) {
    console.warn('[LB Prints Index] no [data-lb-prints-index] container found');
    return;
  }

  const cards = Array.from(container.querySelectorAll('[data-lb-print-card]'));
  const filterChips = Array.from(container.querySelectorAll('[data-lb-filter]'));
  const searchInput = container.querySelector('[data-lb-search-input]');
  const noResults = container.querySelector('[data-lb-no-results]');
  const resetBtn = container.querySelector('[data-lb-reset]');
  const visibleCountEl = container.querySelector('[data-lb-visible-count]');

  console.info(
    `[LB Prints Index] ready · cards=${cards.length} · ` +
    `filter chips=${filterChips.length} · search=${searchInput ? 'yes' : 'no'}`
  );

  let activeFilter = 'all';
  let activeSearch = '';

  function applyFilters() {
    let visible = 0;
    for (const card of cards) {
      const cardCategory = card.dataset.category || '';
      const cardName = card.dataset.name || '';

      const categoryMatch = activeFilter === 'all' || cardCategory === activeFilter;
      const searchMatch = activeSearch === '' || cardName.includes(activeSearch);

      const show = categoryMatch && searchMatch;
      if (show) {
        card.hidden = false;
        visible++;
      } else {
        card.hidden = true;
      }
    }

    // Update visible count
    if (visibleCountEl) visibleCountEl.textContent = visible;

    // Toggle no-results state
    if (noResults) noResults.hidden = visible !== 0;
  }

  // Wire filter chips
  for (const chip of filterChips) {
    chip.addEventListener('click', () => {
      const filter = chip.dataset.lbFilter;
      activeFilter = filter;

      // Update active state on chips
      for (const c of filterChips) {
        const isActive = c === chip;
        c.classList.toggle('lb-prints-index__chip--active', isActive);
        c.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      applyFilters();
    });
  }

  // Wire search input (debounced)
  if (searchInput) {
    let searchTimer;
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        activeSearch = searchInput.value.trim().toLowerCase();
        applyFilters();
      }, 120);
    });
  }

  // Wire reset button
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      activeFilter = 'all';
      activeSearch = '';
      if (searchInput) searchInput.value = '';

      // Reset chip state
      for (const c of filterChips) {
        const isDefault = c.dataset.lbFilter === 'all';
        c.classList.toggle('lb-prints-index__chip--active', isDefault);
        c.setAttribute('aria-pressed', isDefault ? 'true' : 'false');
      }

      applyFilters();
    });
  }

})();
